/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<g opacity="0.4">
				<path
					d="M16 12C16 17.5228 14.2091 22 12 22C9.79086 22 8 17.5228 8 12C8 6.47715 9.79086 2 12 2C14.2091 2 16 6.47715 16 12Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12 8C17.5228 8 22 9.79086 22 12C22 14.2091 17.5228 16 12 16C6.47715 16 2 14.2091 2 12C2 9.79086 6.47715 8 12 8Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<circle
				cx="12"
				cy="12"
				r="10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<ellipse
				opacity="0.12"
				cx="12"
				cy="12"
				rx="4"
				ry="10"
				transform="rotate(-90 12 12)"
				fill="currentColor"
			/>
			<path
				d="M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M22 12C22 9.79086 17.5228 8 12 8C6.47715 8 2 9.79086 2 12M22 12C22 14.2091 17.5228 16 12 16C6.47715 16 2 14.2091 2 12M12 22C6.47715 22 2 17.5228 2 12M12 22C14.2091 22 16 17.5228 16 12C16 6.47715 14.2091 2 12 2M12 22C9.79086 22 8 17.5228 8 12C8 6.47715 9.79086 2 12 2M2 12C2 6.47715 6.47715 2 12 2"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.74995 11.9999C8.74995 10.9228 8.80762 9.88688 8.91382 8.9139C9.88686 8.80768 10.9228 8.75 12 8.75C13.0772 8.75 14.1131 8.80767 15.0861 8.91388C15.1923 9.88686 15.2499 10.9228 15.2499 11.9999C15.2499 13.0771 15.1923 14.1131 15.086 15.0861C14.1131 15.1923 13.0772 15.25 12 15.25C10.9228 15.25 9.88687 15.1923 8.91385 15.0861C8.80762 14.1131 8.74995 13.0771 8.74995 11.9999ZM7.24995 11.9999C7.24995 11.0112 7.29628 10.049 7.38405 9.12908C6.29192 9.31924 5.3103 9.57383 4.47817 9.87642C3.5306 10.221 2.81655 10.6136 2.35341 11.0117C1.88784 11.412 1.75003 11.7485 1.75003 12C1.75003 12.2515 1.88784 12.588 2.35341 12.9883C2.81655 13.3864 3.5306 13.779 4.47817 14.1236C5.3103 14.4262 6.29193 14.6808 7.38407 14.8709C7.29628 13.951 7.24995 12.9887 7.24995 11.9999ZM3.96555 8.46673C5.00471 8.08885 6.22849 7.7862 7.57716 7.57725C7.78611 6.2285 8.08878 5.00463 8.46667 3.96542C8.82648 2.97597 9.26733 2.11806 9.78882 1.47754C5.62603 2.34788 2.3478 5.62616 1.47754 9.78898C2.11807 9.26745 2.97603 8.82656 3.96555 8.46673ZM14.2111 1.47754C14.7326 2.11806 15.1734 2.97597 15.5332 3.96542C15.9111 5.00463 16.2138 6.22848 16.4227 7.57722C17.7715 7.78617 18.9953 8.08884 20.0345 8.46673C21.0239 8.82652 21.8818 9.26735 22.5223 9.7888C21.652 5.62607 18.3738 2.34786 14.2111 1.47754ZM22.5223 14.2112C21.8818 14.7327 21.0239 15.1735 20.0345 15.5333C18.9953 15.9112 17.7714 16.2138 16.4227 16.4228C16.2138 17.7714 15.9111 18.9952 15.5332 20.0344C15.1734 21.0238 14.7326 21.8818 14.2111 22.5223C18.3737 21.652 21.6519 18.3739 22.5223 14.2112ZM9.78881 22.5223C9.26733 21.8818 8.82648 21.0238 8.46667 20.0344C8.0888 18.9952 7.78614 17.7714 7.57719 16.4228C6.22851 16.2138 5.00472 15.9112 3.96555 15.5333C2.97605 15.1735 2.11811 14.7326 1.47759 14.2111C2.34792 18.3738 5.6261 21.652 9.78881 22.5223ZM12 7.25C11.0112 7.25 10.049 7.29634 9.12899 7.38412C9.31915 6.29191 9.57375 5.31022 9.87636 4.47804C10.2209 3.53047 10.6135 2.81642 11.0117 2.35328C11.412 1.88771 11.7485 1.74991 11.9999 1.74991C12.2514 1.74991 12.5879 1.88771 12.9882 2.35328C13.3864 2.81642 13.779 3.53047 14.1235 4.47804C14.4261 5.31022 14.6807 6.2919 14.8709 7.38411C13.951 7.29633 12.9888 7.25 12 7.25ZM16.7499 11.9999C16.7499 11.0112 16.7036 10.049 16.6158 9.12905C17.708 9.31921 18.6897 9.57381 19.5219 9.87642C20.4695 10.221 21.1835 10.6136 21.6467 11.0117C22.1122 11.412 22.25 11.7485 22.25 12C22.25 12.2515 22.1122 12.588 21.6467 12.9883C21.1835 13.3864 20.4695 13.779 19.5219 14.1236C18.6897 14.4262 17.708 14.6808 16.6158 14.871C16.7036 13.951 16.7499 12.9887 16.7499 11.9999ZM12 16.75C12.9887 16.75 13.951 16.7037 14.8709 16.6159C14.6807 17.708 14.4261 18.6896 14.1235 19.5218C13.779 20.4693 13.3864 21.1834 12.9882 21.6465C12.5879 22.1121 12.2514 22.2499 11.9999 22.2499C11.7485 22.2499 11.412 22.1121 11.0117 21.6465C10.6135 21.1834 10.2209 20.4693 9.87636 19.5218C9.57377 18.6896 9.31918 17.708 9.12902 16.6159C10.049 16.7037 11.0113 16.75 12 16.75Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M22 12C22 13.684 19.3983 15.125 15.7149 15.7149M22 12C22 10.881 20.8514 9.8694 19 9.14343M12 22C6.47715 22 2 17.5228 2 12M12 22C13.684 22 15.125 19.3983 15.7149 15.7149M12 22C10.881 22 9.8694 20.8514 9.14343 19M2 12C2 6.47715 6.47715 2 12 2M2 12C2 13.684 4.60173 15.125 8.28511 15.7149M2 12C2 10.316 4.60173 8.87498 8.28511 8.28511M12 2C13.684 2 15.125 4.60173 15.7149 8.28511M12 2C10.316 2 8.87498 4.60173 8.28511 8.28511M15.7149 8.28511C14.5664 8.10118 13.3127 8 12 8C10.6873 8 9.4336 8.10118 8.28511 8.28511M15.7149 8.28511C15.8988 9.4336 16 10.6873 16 12C16 13.3127 15.8988 14.5664 15.7149 15.7149M15.7149 15.7149C14.5664 15.8988 13.3127 16 12 16C10.6873 16 9.4336 15.8988 8.28511 15.7149M8.28511 15.7149C8.10118 14.5664 8 13.3127 8 12"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M22 12C22 9.79086 17.5228 8 12 8C6.47715 8 2 9.79086 2 12M22 12C22 14.2091 17.5228 16 12 16C6.47715 16 2 14.2091 2 12M12 22C6.47715 22 2 17.5228 2 12M12 22C14.2091 22 16 17.5228 16 12C16 6.47715 14.2091 2 12 2M12 22C9.79086 22 8 17.5228 8 12C8 6.47715 9.79086 2 12 2M2 12C2 6.47715 6.47715 2 12 2"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g opacity="0.32">
				<path
					d="M7.24995 11.9999C7.24995 11.0112 7.29628 10.049 7.38405 9.12908C6.29192 9.31924 5.3103 9.57383 4.47817 9.87642C3.5306 10.221 2.81655 10.6136 2.35341 11.0117C1.88784 11.412 1.75003 11.7485 1.75003 12C1.75003 12.2515 1.88784 12.588 2.35341 12.9883C2.81655 13.3864 3.5306 13.779 4.47817 14.1236C5.3103 14.4262 6.29193 14.6808 7.38407 14.8709C7.29628 13.951 7.24995 12.9887 7.24995 11.9999Z"
					fill="currentColor"
				/>
				<path
					d="M3.96555 8.46673C5.00471 8.08885 6.22849 7.7862 7.57716 7.57725C7.78611 6.2285 8.08878 5.00463 8.46667 3.96542C8.82648 2.97597 9.26733 2.11806 9.78882 1.47754C5.62603 2.34788 2.3478 5.62616 1.47754 9.78898C2.11807 9.26745 2.97603 8.82656 3.96555 8.46673Z"
					fill="currentColor"
				/>
				<path
					d="M14.2111 1.47754C14.7326 2.11806 15.1734 2.97597 15.5332 3.96542C15.9111 5.00463 16.2138 6.22848 16.4227 7.57722C17.7715 7.78617 18.9953 8.08884 20.0345 8.46673C21.0239 8.82652 21.8818 9.26735 22.5223 9.7888C21.652 5.62607 18.3738 2.34786 14.2111 1.47754Z"
					fill="currentColor"
				/>
				<path
					d="M22.5223 14.2112C21.8818 14.7327 21.0239 15.1735 20.0345 15.5333C18.9953 15.9112 17.7714 16.2138 16.4227 16.4228C16.2138 17.7715 15.9111 18.9952 15.5332 20.0344C15.1734 21.0238 14.7326 21.8818 14.2111 22.5223C18.3737 21.652 21.6519 18.3739 22.5223 14.2112Z"
					fill="currentColor"
				/>
				<path
					d="M9.78881 22.5223C9.26733 21.8818 8.82648 21.0238 8.46667 20.0344C8.0888 18.9952 7.78614 17.7714 7.57719 16.4228C6.22851 16.2138 5.00472 15.9112 3.96555 15.5333C2.97605 15.1735 2.11811 14.7326 1.47759 14.2111C2.34792 18.3738 5.6261 21.652 9.78881 22.5223Z"
					fill="currentColor"
				/>
				<path
					d="M12 7.25C11.0112 7.25 10.049 7.29634 9.12899 7.38412C9.31915 6.29191 9.57375 5.31022 9.87636 4.47804C10.2209 3.53047 10.6135 2.81642 11.0117 2.35328C11.412 1.88771 11.7485 1.74991 11.9999 1.74991C12.2514 1.74991 12.5879 1.88771 12.9882 2.35328C13.3864 2.81642 13.779 3.53047 14.1235 4.47804C14.4261 5.31022 14.6807 6.2919 14.8709 7.38411C13.951 7.29633 12.9888 7.25 12 7.25Z"
					fill="currentColor"
				/>
				<path
					d="M16.7499 11.9999C16.7499 11.0112 16.7036 10.049 16.6158 9.12905C17.708 9.31921 18.6897 9.57381 19.5219 9.87642C20.4695 10.221 21.1835 10.6136 21.6467 11.0117C22.1122 11.412 22.25 11.7485 22.25 12C22.25 12.2515 22.1122 12.588 21.6467 12.9883C21.1835 13.3864 20.4695 13.779 19.5219 14.1236C18.6897 14.4262 17.708 14.6808 16.6158 14.871C16.7036 13.951 16.7499 12.9887 16.7499 11.9999Z"
					fill="currentColor"
				/>
				<path
					d="M12 16.75C12.9887 16.75 13.951 16.7037 14.8709 16.6159C14.6807 17.708 14.4261 18.6896 14.1235 19.5218C13.779 20.4693 13.3864 21.1834 12.9882 21.6465C12.5879 22.1121 12.2514 22.2499 11.9999 22.2499C11.7485 22.2499 11.412 22.1121 11.0117 21.6465C10.6135 21.1834 10.2209 20.4693 9.87636 19.5218C9.57377 18.6896 9.31918 17.708 9.12902 16.6159C10.049 16.7037 11.0113 16.75 12 16.75Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M3.96555 8.46673C5.00471 8.08885 6.22849 7.7862 7.57716 7.57725C7.78611 6.2285 8.08878 5.00463 8.46667 3.96542C8.82648 2.97597 9.26733 2.11806 9.78882 1.47754C5.62603 2.34788 2.3478 5.62616 1.47754 9.78898C2.11807 9.26745 2.97603 8.82656 3.96555 8.46673Z"
				fill="currentColor"
			/>
			<path
				d="M14.2111 1.47754C14.7326 2.11806 15.1734 2.97597 15.5332 3.96542C15.9111 5.00463 16.2138 6.22848 16.4227 7.57722C17.7715 7.78617 18.9953 8.08884 20.0345 8.46673C21.0239 8.82652 21.8818 9.26735 22.5223 9.7888C21.652 5.62607 18.3738 2.34786 14.2111 1.47754Z"
				fill="currentColor"
			/>
			<path
				d="M22.5223 14.2112C21.8818 14.7327 21.0239 15.1735 20.0345 15.5333C18.9953 15.9112 17.7714 16.2138 16.4227 16.4228C16.2138 17.7715 15.9111 18.9952 15.5332 20.0344C15.1734 21.0238 14.7326 21.8818 14.2111 22.5223C18.3737 21.652 21.6519 18.3739 22.5223 14.2112Z"
				fill="currentColor"
			/>
			<path
				d="M9.78881 22.5223C9.26733 21.8818 8.82648 21.0238 8.46667 20.0344C8.0888 18.9952 7.78614 17.7714 7.57719 16.4228C6.22851 16.2138 5.00472 15.9112 3.96555 15.5333C2.97605 15.1735 2.11811 14.7326 1.47759 14.2111C2.34792 18.3738 5.6261 21.652 9.78881 22.5223Z"
				fill="currentColor"
			/>
			<path
				d="M8.75 11.9999C8.75 10.9228 8.80767 9.88688 8.91388 8.9139C9.88691 8.80768 10.9229 8.75 12.0001 8.75C13.0772 8.75 14.1131 8.80767 15.0861 8.91388C15.1923 9.88686 15.25 10.9228 15.25 11.9999C15.25 13.0771 15.1923 14.1131 15.0861 15.0861C14.1131 15.1923 13.0772 15.25 12.0001 15.25C10.9229 15.25 9.88693 15.1923 8.9139 15.0861C8.80768 14.1131 8.75 13.0771 8.75 11.9999Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
